import {
  GET_TABLE_TYPE,
  GET_TABLE_TYPE_SUCCESS,
  GET_TABLE_TYPE_FAILED,
  GET_OPERATIONAL_DASHBOARD,
  GET_OPERATIONAL_DASHBOARD_SUCCESS,
  GET_OPERATIONAL_DASHBOARD_FAILED,
  GET_WORKFLOW_DETAILS,
  GET_WORKFLOW_DETAILS_SUCCESS,
  GET_WORKFLOW_DETAILS_FAILED,
} from "../actions/operationalDashboard";

export const initialState = {
  tableTypeObj: {
    loading: false,
    error: null,
    data: null,
  },
  operationalDashObj: {
    loading: false,
    error: null,
    data: null,
  },
  workFlowObj: {
    loading: false,
    error: null,
    data: null,
  },
};

export function OperationalDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TABLE_TYPE:
      return {
        ...state,
        tableTypeObj: {
          loading: true,
          error: null,
          data: null,
        },
      };

    case GET_TABLE_TYPE_SUCCESS:
      let all = ["ALL"];
      let remainingContent = action?.payload?.content ?? [];
      return {
        ...state,
        tableTypeObj: {
          loading: false,
          error: null,
          data: all.concat(remainingContent),
        },
      };

    case GET_TABLE_TYPE_FAILED:
      return {
        ...state,
        tableTypeObj: {
          loading: false,
          error: action.error,
          data: null,
        },
      };

    case GET_OPERATIONAL_DASHBOARD:
      return {
        ...state,
        operationalDashObj: {
          loading: true,
          error: null,
          data: null,
        },
      };

    case GET_OPERATIONAL_DASHBOARD_SUCCESS:
      let res = [];
      if (action.params.module == "My Earnings") {
        res[action?.extraData?.subModule] = action.payload;

        // console.log("success", res);
      } else {
        res = action.payload;
      }
      return {
        ...state,
        operationalDashObj: {
          loading: false,
          error: null,
          data: res,
        },
      };

    case GET_OPERATIONAL_DASHBOARD_FAILED:
      return {
        ...state,
        operationalDashObj: {
          loading: false,
          error: action.error,
          data: null,
        },
      };
    case GET_WORKFLOW_DETAILS:
      return {
        ...state,
        workFlowObj: {
          loading: true,
          error: null,
          data: null,
        },
      };

    case GET_WORKFLOW_DETAILS_SUCCESS:
      return {
        ...state,
        workFlowObj: {
          loading: false,
          error: null,
          data: action.payload,
        },
      };

    case GET_WORKFLOW_DETAILS_FAILED:
      return {
        ...state,
        workFlowObj: {
          loading: false,
          error: action.error,
          data: null,
        },
      };

    default:
      return state;
  }
}

export default OperationalDashboardReducer;
